import React, {createContext} from 'react'
import {useLocation} from 'react-router-dom'
import * as queryString from 'query-string'

enum FeatureValue {
    metadata = 'metadata'
}

type FeaturesState = {
    isMetadataEnabled: boolean
}

let featuresState: FeaturesState = {
    isMetadataEnabled: false,
}

const featureFlagToStateMap: Record<FeatureValue, keyof FeaturesState> = {
    [FeatureValue.metadata]: 'isMetadataEnabled',
}

export const FeaturesContext = createContext<FeaturesState>(featuresState)

export const FeaturesProvider: React.FC = ({children}) => {
    const location = useLocation()
    const queries = queryString.parse(location.search)
    const featureString = queries.features as String

    if (featureString) {
        const featureSet = new Set(featureString.split(','))
        for (const featureValue of Object.values(FeatureValue)) {
            const feature = featureFlagToStateMap[featureValue]
            featuresState[feature] = featureSet.has(featureValue)
        }
    }

    return (
        <FeaturesContext.Provider value={featuresState}>
            {children}
        </FeaturesContext.Provider>
    )
}
